import * as React from 'react';
import { IconProps } from '../types';

const IcLink = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M11.194 3.111A7.209 7.209 0 0 1 21.39 13.306l-2.82 2.819-1.944-1.944 2.82-2.82a4.459 4.459 0 0 0-6.306-6.305l-2.82 2.819L8.375 5.93l2.82-2.819ZM11.861 18.944l2.82-2.819 1.944 1.945-2.82 2.819A7.208 7.208 0 0 1 3.612 10.694l2.82-2.819L8.374 9.82l-2.82 2.819a4.459 4.459 0 0 0 6.306 6.305Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m9.347 17.097 8.25-8.25-1.944-1.944-8.25 8.25 1.944 1.944Z"
    />
  </svg>
);

export default IcLink;
